module.exports = __webpack_public_path__ + "static/media/animal_05.7494913b.png";